import { Component, OnInit } from '@angular/core';

import { Location } from '@angular/common';

import { NotificationService } from 'src/app/Service/notification.service';

import { FormGroup, FormBuilder, FormControl, NgForm } from '@angular/forms';

import axios from 'src/app/Service/axios';

import { Observable, map, of, startWith } from 'rxjs';

import { animate, state, style, transition, trigger } from '@angular/animations';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

import { ActivatedRoute } from '@angular/router';

import { OtherService } from 'src/app/Service/other.service';

import * as XLSX from 'xlsx';

declare let $: any;

@Component({

  selector: 'app-driver-service',

  templateUrl: './driver-service.component.html',

  styleUrls: ['./driver-service.component.css'],

  animations: [

    trigger('fadeAnimation', [

      state('void', style({ opacity: 0 })),

      transition(':enter', [

        animate('300ms ease-in', style({ opacity: 1 }))

      ]),

      transition(':leave', [

        animate('100ms ease-out', style({ opacity: 0 }))

      ])

    ])

  ]

})

export class DriverServiceComponent implements OnInit {

  list_drivers: any = [];

  list_Search: any = [];

  list_Schools: any = [];

  list_Students: any = [];

  list_tempService: any = [];

  list_OfficialDrivers: any = [];

  bPlaning: boolean = false;

  bAddStudent: boolean = false;

  bStudentList: boolean = true;

  isLoading: boolean = false;

  bTrip: boolean = false;

  bTripPlaning: boolean = false;

  showFilter: boolean = false;

  iPassenger!: string;

  servicePlaning: any = { bFromHome: false, lstPassenger: [] };

  lstPassenger: any = { iPassenger: '', strSIte: '', strComment: '', tiPriority: '0' };

  editPassenger: any;

  filteredSchools = [];

  filteredStudents = [];

  filteredDrivers = [];

  lst_DailyService: any = [];

  searchT_School = '';

  searchT_Student = '';

  searchT_Driver = '';

  indexStd: number = -1;

  iMobileDomain: number = -1;

  fileName = 'عملکرد سفرهای برنامه ریزی شده.xlsx';

  dateFilter: FormGroup = this.FormBuilder.group({

    fromDate: new FormControl(''),

    toDate: new FormControl(''),

    start: new FormControl(''),

    end: new FormControl('')

  })

  constructor(

    private location: Location,

    private Notification: NotificationService,

    private FormBuilder: FormBuilder,

    private gurdService: GurdServiceService,

    private _route: ActivatedRoute,

    private _otherService: OtherService

  ) { }

  ngOnInit(): void {

    this._route.url.subscribe((segment) => {

      if (segment[0].path == 'planning-travel') { // 1

        this.bTrip = true;

        this.getMobile_Offitial()

      }

      if (segment[0].path == 'planning-trip') {

        this.bTripPlaning = true;

      }

      this.getSchools();

      this.dateFilter.valueChanges.subscribe(() => {

        this.servicePlaning.strSDate = this.dateFilter.value.start;

        this.servicePlaning.strEDate = this.dateFilter.value.end;

      })


    })

  }

  filterSchool() {

    if (this.searchT_School == '') {

      this.filteredSchools = [];

      this.bStudentList = false;

    }

    else {

      this.bStudentList = false;

      this.filteredSchools = this.list_Schools.filter((item: any) => item.strComment.includes(this.searchT_School));

      this.searchT_Student = ''

    }
  }

  filterStudent() {

    this.bStudentList = true;

    if (this.searchT_Student == '') this.filteredStudents = []

    else {

      this.filteredStudents = this.list_Students.filter((item: any) => item.strFullName.includes(this.searchT_Student));

    }

  }

  filterDriver() {

    this.filteredDrivers = this.list_OfficialDrivers.filter((item: any) =>

      item?.strFullName.includes(this.searchT_Driver) ||

      item?.strCellNo.includes(this.searchT_Driver)

    );

    this.searchT_Driver = ''

  }

  goBack() {

    this.location.back();
  }

  async searchDriver(form: NgForm) {

    if (form.value.strMobile == '' || this.dateFilter.value.fromDate == "" || this.dateFilter.value.toDate == "") return this.Notification.showError('لطفا تمام فیلد هارا پر کنید');

    this.isLoading = true;

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      strMobile: form.value.strMobile,

      strSDate: this.dateFilter.value.fromDate != null ? this.dateFilter.value.fromDate : '',

      strEDate: this.dateFilter.value.toDate != null ? this.dateFilter.value.toDate : ''

    }

    //  برنامه ریزی سفرهای پرسنل 

    if (this.bTrip) model.strMobile = this.servicePlaning.strMobile;

    // 

    else this.servicePlaning.strMobile = form.value.strMobile;

    let res = JSON.parse((await axios.post(`School_DailyServicePlanning_Search`, model)).data.toString());

    this.isLoading = false;

    if (res.iResult == 0 && res?.strError != '') return this.Notification.showError(res.strError);

    this.list_drivers = res;

    this.list_Search = res;

    this.bPlaning = false;

  }

  async getSchools() {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    }

    let res = JSON.parse((await axios.post(`School_User_List`, model)).data.toString())

    this.list_Schools = res;
  }

  driverPlaning() {

    this.bPlaning = true;

    this.searchT_School = '';

    this.searchT_Student = '';

    setTimeout(() => {

      $('.clockpicker').clockpicker({

        donetext: 'top',

        align: 'top',

        autoclose: true,

      });

    }, 200);

  }

  onSchool(item: any) {

    this.servicePlaning.iMobileDomain = item.iMobileDomain;

    this.servicePlaning.iSystemUser = this.gurdService.decrypt(localStorage.getItem('ID')!);

    this.servicePlaning.strSession = this.gurdService.decrypt(localStorage.getItem('Session')!);


  }

  mdlService(type: any, item: any, filter?: any) {

    this.lstPassenger[type] = item;

    if (filter) {

      this.filteredStudents = [];

      this.searchT_Student = filter;

    }

  }

  newService() {

    let audience = this.bTrip ? ' پرسنل ' : ' دانش آموز ';

    if (this.lstPassenger.iPassenger == '') return this.Notification.showError(`نام ${audience} را انتخاب کنید`);

    if (this.lstPassenger.iPassenger == '') return this.Notification.showError(``);

    this.list_tempService.push(this.lstPassenger);

    this.bAddStudent = false;

    this.lstPassenger = { iPassenger: '', strSIte: '', strComment: '', tiPriority: '0' };

    this.searchT_Student = '';

    this.filteredStudents = this.list_Students;


  }

  getStdName(iPassenger: any) {

    const student = this.list_Students.find((el: any) => el.iPassenger == iPassenger);

    return student.strFullName

  }

  removeStd(std: [], index: number) {

    this.list_tempService.splice(index, 1)

  }

  addStd_Service(index: number) {

    this.filteredStudents = [];

    this.searchT_School = '';

    this.searchT_Student = '';

    document.querySelectorAll('.collapse').forEach((a: any, i: number) => {

      if (i == index) {

        a.classList.toggle('d-revert');

        a.classList.toggle('d-none');

      }

      else {

        a.classList.remove('d-revert');

        a.classList.add('d-none');
      }

    })


  }

  backTo() {

    if (this.list_tempService.length > 0) {

      $.confirm({

        title: `آیا قصد بازگشت بدون ذخیره اطلاعات را دارید ؟`,

        content: '',

        type: 'red',

        buttons: {

          ok: {

            text: "بازگشت",

            btnClass: 'btn-danger',

            keys: ['enter'],

            action: async () => {

              this.list_tempService = [];

              this.bPlaning = false;

            }

          },

          cancel: {

            text: "لغو",

          }

        }

      });

    }

    else this.bPlaning = false;

  }

  selectStudent(item: any) {

    this.bStudentList = false;

    this.searchT_Student = item.strPassenger_FullName;

    this.iPassenger = item.iPassenger;

  }

  editMode(item: any, i: number) {

    this.editPassenger = item;

    this.searchT_Student = item.strPassenger_FullName;

    if (this.indexStd != -1 || this.indexStd == i) {

      this.list_tempService[this.indexStd].editMode = false;

      this.indexStd = -1;


    }

    else {

      this.list_tempService[i].editMode = true;

      this.indexStd = i

    }



  }

  editStudent(index: number) {

    this.list_tempService[index] = this.editPassenger;

    this.list_tempService[index].editMode = false;
  }

  searchBy(search: any) {

    if (search.length > 2) {

      this.list_drivers = this.list_Search.filter((el: any) => {

        return el.strDate.includes(search)
          || el.strDayName.includes(search)
          || el.strFullName.includes(search)
          || el.strDriver_Mobile.includes(search)
          || el.strName.includes(search)
          || el.strFamily.includes(search)
          || el.strMobile.includes(search)
          || el.strMobileDomain_strComment.includes(search)

      })
    }

    else if (search == '') this.list_drivers = this.list_Search
  }

  async removeService(service: any) {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      iDailyServicePlanningPassenger: service.iDailyServicePlanningPassenger

    }

    $.confirm({

      title: `آیا حذف این سرویس اطمینان دارید ؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            let res = JSON.parse((await axios.post(`School_DailyServicePlanning_Delete`, model)).data.toString())

            if (res.iResult == 0) return this.Notification.showError(res.strError);

            else {

              this.Notification.showSuccess('عمیات با موفقیت انجام شد');

              const index = this.list_drivers.indexOf(service);

              if (index != -1) this.list_drivers.splice(index, 1)

            }

          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });

  }

  async remove_PlaningService() {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      strMobile: this.servicePlaning.strMobile,

      strSDate: this.dateFilter.value.fromDate,

      strEDate: this.dateFilter.value.toDate

    }

    $.confirm({

      title: `آیا حذف این برنامه ریزی اطمینان دارید ؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            let res = JSON.parse((await axios.post(`School_DailyServicePlanning_DeleteAll`, model)).data.toString())

            if (res.iResult == 0) return this.Notification.showError(res.strError);

            else {

              this.Notification.showSuccess('عمیات با موفقیت انجام شد');

              setTimeout(() => {

                this.list_drivers = []

              }, 1000);

            }

          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });

  }

  async submitService() {

    let strMinTime = (document.getElementById("sTime") as HTMLInputElement).value;

    let strMaxTime = (document.getElementById("eTime") as HTMLInputElement).value;

    if (this.servicePlaning.strMobile == undefined) return this.Notification.showError('شماره موبایل راننده را وارد کنید')

    if (!this.servicePlaning.strEDate || !this.servicePlaning.strSDate || strMinTime == '' || strMaxTime == '') return this.Notification.showError('لطفا فرم را با دقت تکمیل کنید');

    if (this.list_tempService.length == 0) return this.Notification.showError('لطفا دانش آموزان خود را انتخاب کنید');

    if (this.list_tempService.length > 0) this.servicePlaning.lstPassenger = this.list_tempService;

    this.servicePlaning.strMinTime = strMinTime;

    this.servicePlaning.strMaxTime = strMaxTime;

    this.servicePlaning.iSystemUser = this.gurdService.decrypt(localStorage.getItem('ID')!);

    this.servicePlaning.strSession = this.gurdService.decrypt(localStorage.getItem('Session')!);

    $.confirm({

      title: `آیا ذخیره اطلاعات اطمینان دارید ؟`,

      content: '',

      type: 'green',

      buttons: {

        ok: {

          text: "ذخیره",

          btnClass: 'btn-success',

          keys: ['enter'],

          action: async () => {

            let res = JSON.parse((await axios.post(`School_DailyServicePlanning_Save`, this.servicePlaning)).data.toString())

            if (res.iResult == 0) return this.Notification.showError(res.strError);

            else {

              this.Notification.showSuccess('عمیات با موفقیت انجام شد')

              this.list_tempService = [];

              this.bPlaning = false;

              this.dateFilter.reset();

            }


          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });


  }

  async submit_stdAdd(item: any) {

    if (this.iPassenger == undefined) return this.Notification.showError('نام دانش آموز را انتخاب کنید')

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      iDailyServicePlanningPassenger: item.iDailyServicePlanningPassenger,

      iPassenger: this.iPassenger

    }

    let res = JSON.parse((await axios.post(`School_DailyServicePlanning_AddPassenger`, model)).data.toString());

    if (res.iResult == 0) return this.Notification.showError(res.strError);

    else {

      this.Notification.showSuccess('عمیات با موفقیت انجام شد')

      this.list_drivers.push(res[0]);

      var collapse = document.querySelectorAll('.collapse');

      collapse.forEach((a: any) => {

        a.classList.remove('d-revert');

        a.classList.add('d-none');

      })

    }


  }

  async getStudent(item: any, disabled?: string,) {

    this.searchT_School = item.strComment;

    this.filteredSchools = []

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      strMobile: '',

      strFullName: '',

      tiSex: -1,

      iMobileDomain: this.iMobileDomain = item.iMobileDomain

    }

    let res = JSON.parse((await axios.post(`School_Passenger_List`, model)).data.toString());

    this.bStudentList = true;

    this.list_Students = res;

    this.filteredStudents = res;

  }

  async getDriverStd() {

    this.isLoading = true;

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      strMobile: this.servicePlaning.strMobile,

      iMobileDomain: this.iMobileDomain

    }

    let res = JSON.parse((await axios.post(`School_Mobile_PassengersSearchByMobile`, model)).data.toString());

    this.isLoading = false;

    if (res.iResult == 0) return this.Notification.showError(res.strError)

    res.forEach((std: any) => {

      this.list_tempService.push({

        iPassenger: std.iPassenger,

        strSIte: std.strSIte ? std.strSIte : '',

        strComment: std.strComment ? std.strComment : '',

        tiPriority: std.tiPriority ? std.tiPriority : '',

        strPassenger_FullName: std.strPassenger_FullName ? std.strPassenger_FullName : '',

      });

    })

  }

  async getMobile_Offitial() {

    this.isLoading = true;

    var model = this._otherService.stringNumberToNumber({

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      tiAppusage: 1

    })

    let res = JSON.parse((await axios.post(`Mobile_Offitial_List`, model)).data.toString());

    this.isLoading = false;

    if (res.iResult == 0) return this.Notification.showError(res.strError);

    this.list_OfficialDrivers = res;

    this.showFilter = true;

  }

  selectDriver(item: any): any {

    if (!item) return this.servicePlaning.strMobile = null;

    else {

      this.searchT_Driver = item.strFullName;

      this.servicePlaning.strMobile = item.strCellNo != '' ? item.strCellNo : item.strMobile;

      this.filteredDrivers = [];

    }

  }

  isScheduleSelected(item: number): boolean {

    return this.lst_DailyService.indexOf(item) !== -1;

  }

  markSchedule(value: boolean, item: any) {

    if (value) {

      this.lst_DailyService.push(item.iDailyServicePlanningPassenger);


    }

    if (!value) {

      const index = this.lst_DailyService.indexOf(item.iDailyServicePlanningPassenger);

      if (index > -1) this.lst_DailyService.splice(index, 1);

    }

  }

  markAllSchedule() {

    if (this.lst_DailyService.length == this.list_drivers.length) {

      this.lst_DailyService = [];

      this.Notification.showSuccess('عملیات با موفقیت انتخاب شدند')

    }

    else {

      this.lst_DailyService = [];

      this.list_drivers.forEach((el: any) => {

        this.lst_DailyService.push(el.iDailyServicePlanningPassenger);

      })

      this.Notification.showSuccess('عملیات با موفقیت انتخاب شدند');

    }

  }

  removeSchedule_ByGroup = async () => {

    if (!this.lst_DailyService.length) return this.Notification.showError('لیست انتخابی شما خالی می باشد');

    $.confirm({

      title: `آیا از حذف ${this.lst_DailyService.length} مورد برنامه ریزی اطمینان دارید ؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            this.isLoading = true;

            var model = this._otherService.stringNumberToNumber({

              iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

              strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

              lstiDailyServicePlanningPassenger: this.lst_DailyService

            })

            const resp = await axios.post(`School_DailyServicePlanning_DeleteAll`, model);

            this.isLoading = false;

            let res = JSON.parse(resp.data);

            if (res.bError) return this.Notification.showError(res.strError);

            this.list_drivers = this.list_drivers.filter((el: any) => {

              for (const passenger of this.lst_DailyService) {

                if (el.iDailyServicePlanningPassenger.toString().includes(passenger.toString())) {

                  return false;

                }

              }

              return true;

            });

            this.Notification.showSuccess("با موفقیت حذف شد");

            this.lst_DailyService = [];


          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });


  }

  exportexcel(id: any): void {
    /* pass here the table id */
    let element = document.getElementById(`${id}`);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.fileName);
  }


}
